import { Table, TableCell, TableRow } from '@ui/components/Table';
import { AdminManagerDto } from '@features/shared/api/typings';

import styles from './ClubAdminManagers.module.css';
import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Input } from '@ui/components/Input';
import { useCallback, useState } from 'react';
import { ThemeButton } from '@ui/components/ThemeButton';
import { HorizontalScroll } from '@ui/components/HorizontalScroll';

type Props = {
  managers: AdminManagerDto[];
  onAdd: (email: string) => Promise<void>;
  onRemove: (email: string) => Promise<void>;
  disabled?: boolean;
};

export function ClubAdminManagers({ managers, onAdd, onRemove, disabled }: Props) {

  const [newManagerEmail, setNewManagerEmail] = useState<string>('');

  const handleAdd = useCallback(async () => {
    try {
      await onAdd(newManagerEmail);
      setNewManagerEmail('');
    } finally {}
  }, [onAdd, newManagerEmail, setNewManagerEmail]);

  return (
    <div className={styles.root}>
      <FormRow>
        <FormLabel>
          Добавить менеджера
        </FormLabel>
        <FormInput>
          <Input
            placeholder="E-mail"
            value={newManagerEmail}
            onChange={setNewManagerEmail}
          />

          <ThemeButton onClick={handleAdd} disabled={disabled || !newManagerEmail}>
            Добавить
          </ThemeButton>
        </FormInput>
      </FormRow>

      <HorizontalScroll>
        <Table>
          <TableRow header>
            <TableCell className={styles.idColumn}>ID</TableCell>
            <TableCell className={styles.mailColumn} leftGap>
              Email
            </TableCell>
            <TableCell className={styles.nameColumn} leftGap>
              Имя и фамилия
            </TableCell>
            <TableCell>{/* renderActions */}</TableCell>
          </TableRow>

          {
            managers.map(m => (
              <TableRow key={m.id}>
                <TableCell>{ m.userId }</TableCell>
                <TableCell leftGap>{ m.email }</TableCell>
                <TableCell leftGap>{ m.firstName } { m.lastName }</TableCell>
                <TableCell leftGap right>
                  <ThemeButton disabled={disabled} compact onClick={() => onRemove(m.email)}>
                    Удалить
                  </ThemeButton>
                </TableCell>
              </TableRow>
            ))
          }
        </Table>
        {!managers.length && (
          <div className={styles.placeholder}>
            Нет менеджеров
          </div>
        )}
      </HorizontalScroll>
    </div>
  );
}
